import React from 'react';

const BackArrow = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M15 7.00022H3.82998L8.70998 2.12021C9.09998 1.73021 9.09998 1.09021 8.70998 0.700215C8.31998 0.310215 7.68998 0.310215 7.29998 0.700215L0.70998 7.29022C0.31998 7.68021 0.31998 8.31021 0.70998 8.70021L7.29998 15.2902C7.68998 15.6802 8.31998 15.6802 8.70998 15.2902C9.09998 14.9002 9.09998 14.2702 8.70998 13.8802L3.82998 9.00021H15C15.55 9.00021 16 8.55021 16 8.00022C16 7.45021 15.55 7.00022 15 7.00022Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export default BackArrow;
